// extracted by mini-css-extract-plugin
module.exports = {"form-control":"CourseInput_form-control__17vjl","invalid":"CourseInput_invalid__2Ppzt","test":"CourseInput_test__3TogS"};